import { Injectable } from '@angular/core';
import { Command } from '../models/command';
//import { CoresService } from '../services/cores.service';
import { CoreService } from '../services/core.service';

@Injectable({
  providedIn: 'root'
})
export class DefaultSelectionIndicatorCommand implements Command {
  name = 'Set Selection';
  id = this.generateId();
  icon = 'assets/img/crosshair.svg';
  modesVisible: string[] = [];
  private mapEntity: any;

  constructor(private Core: CoreService) {}

  private generateId(): string {
    return 'selection-' + Math.random().toString(36).substr(2, 9);
  }

  shouldShow = () => true;

  init = (entity: any) => {
    this.mapEntity = entity;
    if (this.Core.getSelectedEntity()) {
      this.setSelectionIcon(
        entity.getCesiumEntity()._id === 
        this.Core.getSelectedEntity().getCesiumEntity()._id
      );
    } else {
      this.setSelectionIcon(false);
    }
  };

  execute = () => {
    if (this.Core.getSelectedEntity()) {
      if (this.mapEntity.getCesiumEntity()._id !== 
          this.Core.getSelectedEntity().getCesiumEntity()._id) {
        // Using Angular's EventEmitter instead of $rootScope.$broadcast
        this.Core.selectionIndicatorChanged.emit(this.mapEntity);
        this.setSelectionIcon(true);
      } else {
        this.Core.selectionIndicatorChanged.emit(null);
        this.setSelectionIcon(false);
      }
    } else {
      this.Core.selectionIndicatorChanged.emit(this.mapEntity);
      this.setSelectionIcon(true);
    }
  };

  private setSelectionIcon(selected: boolean): void {
    this.icon = selected ? 
      'assets/img/crosshair_selected.svg' : 
      'assets/img/crosshair.svg';
  }
}
